import { AuthType, type Config } from '@snapchat/metrics-utils';
import { WebAuthenticator } from '../auth/WebAuthenticator';
import {
  WebMetricCollector,
  type WebMetricCollectorOptions,
} from '../collector/WebMetricCollector';

/** Network config for RTAM server (for web metrics) */
export const getWebConfig = (collectorOptions: WebMetricCollectorOptions): Config => ({
  protocol: 'https:',
  host: 'gcp.api.snapchat.com',
  path: '/web/metrics',
  headers: {
    'Content-Type': 'application/x-protobuf',
  },
  authType: AuthType.WebAttestation,
  authenticator: new WebAuthenticator(),
  collector: new WebMetricCollector(collectorOptions),
});
